// extracted by mini-css-extract-plugin
export default {"mainBlock":"YouTube_mainBlock__bwORw"};